<template>
  <v-flex xs4>
    <v-card :raised="!address.default">
      <v-card-text>
        <strong>{{address.first_name}} {{address.last_name}}<br></strong>
        {{address.street1}}<br>
        <template v-if="street2">{{address.street2}}<br></template>
        {{address.city}}, {{address.state}} {{address.zip}}
      </v-card-text>
      <v-card-actions>
        <v-icon v-if="address.validated">mdi-map-marker-check</v-icon>
        <v-icon v-if="address.default">mdi-bookmark</v-icon>
        <v-spacer/>
        <v-btn flat icon small @click="$emit('edit', address)"><v-icon>mdi-pencil</v-icon></v-btn>
        <v-btn flat icon small @click="$emit('delete', address.id)"><v-icon>mdi-delete</v-icon></v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  props: {
    address: Object
  },

  computed: {
    street2 () {
      return this.address.street2
    }
  }
}
</script>



// WEBPACK FOOTER //
// shipping-address.vue?8ee4b8f4